// extracted by mini-css-extract-plugin
module.exports = {"QueueMenu":"QueueMenu_QueueMenu__ZmhGs"};